import {
  useContext,
} from 'react';
import styled from "styled-components";

import { ThemeContext } from '@dstantwo/ullr-react-components';

import CONSTANTS from '../constants';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export const PageContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100vw;
  min-height: 100vh;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  background: ${() => useContext(ThemeContext).COLORS.OFF_WHITE};
  padding-top: 56px;
  @media ${CONSTANTS.DEVICE_SIZE.tablet} { 
    padding-top: 28px;
  }
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 600px;
  padding: 0px 12px;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  margin-left: 20px;

  @media ${CONSTANTS.DEVICE_SIZE.tablet} { 
    margin-bottom: 24px;
  }
`;

  // border-width: 1px;
  // border-style: solid;
  // border-color: #ff0000;

export const LoginHeader = styled.h2`
  font-weight: 700;
  font-size: 24px;
  align-self: flex-start;
  margin: 0px 0px 36px 0px;
`;

export const UllrLogo = styled.h2`
  font-weight: 700;
  font-size: 24px;
  margin: 0px;
  margin-left: 12px;
`;

export const InnerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;

  width: 80%;
  @media ${CONSTANTS.DEVICE_SIZE.tablet} { 
    width: 95%;
  }
`;

export const LinkText = styled.span`
  align-self: flex-end;
  margin-bottom: 20px;
  color: ${() => useContext(ThemeContext).COLORS.PRIMARY};
  &:hover {
    cursor: pointer;
    color: ${() => useContext(ThemeContext).COLORS.DARK};
  }
`;

export const Link = styled.a`
  color: ${() => useContext(ThemeContext).COLORS.PRIMARY};
  &:hover {
    cursor: pointer;
    color: ${() => useContext(ThemeContext).COLORS.DARK};
  }
`;

export const ErrorText = styled.span`
  font-size: 16;
  font-weight: bold;
  color: ${() => useContext(ThemeContext).COLORS.RED_ALERT};
`;

export const InstructionText = styled.span`
  color: ${() => useContext(ThemeContext).COLORS.DARK_GRAY};
  margin-bottom: 24px;
`;

export const SignUpPromptContainer = styled.div`
  padding-top: 32px;
  padding-left: 20px;
`;

export const LoadingMessage = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${() => useContext(ThemeContext).COLORS.DARK};
  text-align: center;
  margin-bottom: 32px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
`;
